import { github, SyntaxHighlighter } from '../../lib/react-syntax-highlighter';
import React from 'react';

import block from 'propmods';

import './SmartHomeTestPageHistoryHighlighter.scss';

const b = block('SmartHomeTestPageHistoryHighlighter');

interface Props {
    data: string;
}

const SmartHomeTestPageHistoryHighlighter: React.FC<Props> = ({ data }) => {
    return (
        <div {...b()}>
            <SyntaxHighlighter language="text" style={github}>
                {data}
            </SyntaxHighlighter>
        </div>
    );
};

export default SmartHomeTestPageHistoryHighlighter;
